import {
  Form,
  Input,
  Select,
  AutoComplete,
  Button,
  Card,
  Spin,
  InputNumber,
  Tag,
  Icon,
  Tooltip,
  Row,
  Col,
  Typography,
} from "antd";
import React, { Component } from "react";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import { PackageAndPrivilegeService } from "../../services/packageAndPrivilege/PackageAndPrivilegeService";
import "./Accounts.css";
import "./AccountForm.css";
import "./UpdateAccountForm.css";
import "./ManageAccountNumberForm.css";
import history from "../../utils/history";
import { Translation } from "react-i18next";
import i18next from "i18next";
const { Text } = Typography;

const prefNum = "010";
class ManageAccountNumberForm extends Component {
  packageAndPrivilegeService = new PackageAndPrivilegeService();
  accountService = new AccountService();

  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("addAccountNumbers");
    this.state = {
      account: {},
      cfg: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      inputVisible: false,
      inputValue: "",
      tags: [],
      packages: [],
      accountNumbers: [],
      msisdn: "",
      newAccountNumbers: [],
      toggleAddMsisdn:false
    };
  }
  async getAllPackages() {
    try {
      let data = await this.packageAndPrivilegeService.getPackagesList(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllAccountMSISDN() {
    try {
      let data = await this.accountService.getAllAccountMSISDN(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let [packages, account, accountNumbers] = await Promise.all([
        this.getAllPackages(),
        this.getAccountData(),
        // this.getAllAccountMSISDN(),
      ]);

      // accountNumbers.ivrList.push({msisdn:this.state.cfg.account_numbers})
      this.setState({
        packages: packages.ivrList,
        // accountNumbers: accountNumbers.ivrList,
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  async getAccountData() {
    let { id } = this.props.match.params;
    let { isFetching } = this.state;
    this.acc = new AccountService();
    try {
      this.setState({ isFetching: true });
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        id
      );
      var cfg = {};
      cfg.pkg_name = "";
      cfg.agents_max_num = "";
      cfg.account_numbers = [];

      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_numbers = [];
            } else {
              cfg.account_numbers = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
        });
      }
      this.setState({
        account: account.ivrCustomEntityObject,
        isFetching: false,
        cfg: cfg,
        tags: cfg.account_numbers,
        // tags:[]
      });
    } catch (error) {
      this.setState({
        isFetching: false,
      });
      handleError(error);
    }
  }

  handleDropdownPackagesChange = (e) => {
    this.setState({ inputValue: e });
  };

  handleChange(e) {
    const { id, value } = e.target;
    let { account } = this.state;
    account[id] = value;
    this.setState({ account });
  }

  handleDropdownChange(value) {
    let { account } = this.state;
    account.accountStatus = value;
    this.setState({ account });
  }

  handleConfirm = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      values.accountId = this.state.account.accountId;
      values.accountStatus = this.state.account.accountStatus;
      let msisdns = [];
      if (this.state.newAccountNumbers.length > 0) {
        msisdns = this.state.newAccountNumbers.map((element) => {
          if (!element.deleted) {
            return element.msisdn;
          }
        });
      }
      if (msisdns.length) {
        msisdns = msisdns.filter((element) => {
          return element != undefined;
        });
      }

      if (msisdns.length) {
        // for (var i = 0; i < this.state.cfg.account_numbers.length; i++) {
        //   msisdns.push(this.state.cfg.account_numbers[i]);
        // }
      } else {
        handleError({
          message: i18next.t("You haven't added any account number yet"),
        });
        return;
      }
      let cfg = [
        {
          key: "PKG_NAME",
          value: this.state.cfg.pkg_name,
          configCategory: "GENERAL",
          accountID: this.state.account.accountId,
        },
        {
          key: "AGENTS_MAX_NUMBER",
          value: this.state.cfg.agents_max_num,
          configCategory: "GENERAL",
          accountID: this.state.account.accountId,
        },
        {
          key: "ACCOUNT_NUMBERS",
          value: msisdns.length != 0 ? msisdns.join() : [],
          configCategory: "GENERAL",
          accountID: this.state.account.accountId,
        },
        // {
        //   key: "ASSIGNED_ACCOUNT_NUMBERS",
        //   value: this.state.cfg.account_numbers.join(),
        //   configCategory: "GENERAL",
        //   accountID: this.state.account.accountId
        // }
      ];
      values.BIVRNumbers = msisdns;
      values.cfg = cfg;
      try {
        if (!err) {
          this.setState({ loading: true });
          this.acc = new AccountService();

          let data = await this.acc.addBIVRNumbers(
            this.props.context.session_id,
            values
          );
          this.setState({ loading: false });
          showSuccessToast(i18next.t("Account edited successfully"));
          this.setState({ newAccountNumbers: [] });

          history.push(
            `/home/accounts/manageAccountNumbers/${values.accountId}`
          );
        }
      } catch (e) {
        this.setState({ loading: false });

        handleError(e);
      }
    });
  };

  handleClose = (removedTag) => {
    const tags = this.state.tags.filter((tag) => tag !== removedTag);
    this.setState({ tags, inputVisible: true });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, prefNum + inputValue];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: "",
    });
  };
  handleChangeMaxAgents(e) {
    let value = e;
    let { cfg } = this.state;
    cfg.agents_max_num = value;
    this.setState({ cfg });
  }
  handlePackageName(e) {
    let value = e;
    let { cfg } = this.state;
    // account[id] = value;
    cfg.pkg_name = value;
    this.setState({ cfg });
  }

  handleChangeNumOfAccountNums(e) {
    let value = e;
    this.setState({ tags: [] });
  }

  getNotDeletedNumbers = (accNumbers)=>{
      return accNumbers.filter((elem)=> elem.deleted == null)
  }


  saveInputRef = (input) => (this.input = input);
  render() {
    const {
      account,
      tags,
      inputVisible,
      inputValue,
      packages,
      accountNumbers,
    } = this.state;
    const { status } = this.props;

    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { Option } = Select;
    let { isFetching } = this.state;
    const packageOptions = packages.map((opt) => (
      <Option key={opt.pkgCode} value={opt.pkgCode}>
        {opt.pkgName}
      </Option>
    ));
    var accountNumbersOptions = accountNumbers.map((opt) => (
      <Option key={opt.msisdn} value={opt.msisdn}>
        {opt.msisdn}
      </Option>
    ));

    return (
      <Translation>
        {(t) => (
          <Page title={t("Add Business IVR Number")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    {/* <Form.Item label="Account Numbers" {...formItemLayout}>
                    {getFieldDecorator(
                      "ACCOUNT_NUMBERS",
                      // { initialValue: this.state.cfg.account_numbers },
                      {
                        rules: [
                          {
                            required: true,
                            message: "Please select account numbers",
                          },
                        ],
                      },
                      tags.length !== 0
                        ? {
                            initialValue: tags,
                          }
                        : {}
                    )(<Select mode="multiple">{accountNumbersOptions}</Select>)}
                  </Form.Item> */}

                    <Form.Item
                      // style={{
                      //   display:
                      //     this.props.context.user.msisdnType === "alphanumeric"
                      //       ? "block"
                      //       : "none",
                      // }}
                      label={t("Business IVR Numbers")}
                      {...formItemLayout}
                      
                    >
                      <Row gutter={24}>
            <Col span={20}>

           
                      {getFieldDecorator("ACCOUNT_NUMBERS", {
                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                            // pattern:
                            //   this.props.context.user.msisdnType ===
                            //   "alphanumeric"
                            //     ? "^[a-zA-Z0-9_@$.*]*$"
                            //     : new RegExp("^[0-9]{11}$"),
                            min: 12,
                            max: 12,
                            pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",

                          },
                          {
                            required:
                              this.state.newAccountNumbers.length == 0
                                ? true
                                : false,
                            message: t("Please enter account numbers"),
                          },
                        ],
                      })(
                        <Input
                          onChange={(e) => {
                            if(e.target.value.trim().length ==12 && /^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(e.target.value)){
                            this.setState({
                              toggleAddMsisdn: true,
                              // spanValue: 22,
                              msisdn: e.target.value,
                            });
                          }else{
                            this.setState({
                              toggleAddMsisdn: false,
                              // spanValue: 24,
                              msisdn: "",
                            });
                          }
                           
                          }}
                          maxLength={12}
                          placeholder={t(
                            "Write msisdn and press enter to add business IVR number"
                          )}
                          onPressEnter={(e) => {
                            if(e.target.value.trim().length ==12 && /^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(e.target.value)){
                              let accountNumber = { msisdn: this.state.msisdn };
                              let accountNumbers = this.state.newAccountNumbers;
                              accountNumbers.push(accountNumber);
                              this.setState({
                                newAccountNumbers: accountNumbers,
                                toggleAddMsisdn: false,

                              });
  
                              this.props.form.setFields({
                                ACCOUNT_NUMBERS: {
                                  value: "",
                                },
                              });
                            }else{
                              return;
                            }
                          
                          }}
                        />
                      )}
                      </Col>
               { this.state.toggleAddMsisdn &&  <Col span={2}>
<Button onClick={()=>{
    if(this.state.msisdn.trim().length ==12 && /^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(this.state.msisdn)){
      let accountNumber = { msisdn: this.state.msisdn };
      let accountNumbers = this.state.newAccountNumbers;
      accountNumbers.push(accountNumber);
      this.setState({
        newAccountNumbers: accountNumbers,
        toggleAddMsisdn: false,

      });

      this.props.form.setFields({
        ACCOUNT_NUMBERS: {
          value: "",
        },
      });
    }else{
      return;
    }
}}    className="ant-btn-primary"
>Add</Button>
                    </Col>}
                    </Row>
                    </Form.Item>
                    <Row gutter={24}>
                      <Col span={6}></Col>
                      <Col span={16}>
                        {this.getNotDeletedNumbers(this.state.newAccountNumbers).length ==0 && (
                          <Text>
                            {t("You haven't added any account number yet")}
                          </Text>
                        )}
                        {this.state.newAccountNumbers.map((element, index) => {
                          return (
                            <Tag
                              key={index}
                              closable={true}
                              onClose={() => {
                                let deletedIndex = index;
                                let newArray = [];
                                newArray = this.state.newAccountNumbers.map(
                                  (element, i) => {
                                    if (i == deletedIndex) {
                                      element.deleted = true;
                                    }
                                    return element;
                                  }
                                );
                                this.setState({ newAccountNumbers: newArray });
                              }}
                              style={{ marginTop: "5px" }}
                            >
                              {element.msisdn}
                            </Tag>
                          );
                        })}
                      </Col>
                    </Row>

                  { this.getNotDeletedNumbers(this.state.newAccountNumbers).length >0 && <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.handleConfirm}
                        size={"small"}
                        loading={this.state.loading}
                      >
                        {t("Submit")}
                      </Button>
                    </Form.Item>}
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
  export default Form.create()(
    withSharedStateConsumer(withRouter(ManageAccountNumberForm))
  );
  